import React, { forwardRef, useState } from "react";
import { Redirect } from "react-router-dom";

import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Email from "@mui/icons-material/Email";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

import Header from "components/Header/Header.jsx";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import "assets/css/login.css";

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function LoginPage() {
  const [Correo, setCorreo] = useState("");
  const [Pass, setPass] = useState("");
  const [Codigo, setCodigo] = useState("");
  const [DatosUsuario, setDatosUsuario] = useState({});
  const [isAuth, setIsAuth] = useState(localStorage.getItem("userPortafolios") !== null);

  const [openDialog, setOpenDialog] = useState(false);

  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  
  const getYear = () => {
    return new Date().getFullYear();
  }

  const SnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const sendSnackBar = (pmessage, pcolor) => {
    setOpenSnackbar(true);
    setColor(pcolor);
    setMessage(pmessage);
  };

  const Login = async () => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
            headers: {
                "Content-Type": "application/json"
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Login",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
      sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const UsuarioLogin = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Usuario/Login",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
      sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ValidaCodigo = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Usuario/ValidaCodigo",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
      sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const ActualizaCodigo = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Usuario/ActualizaCodigo",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
      sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const Validar = () => {
    Login()
    .then(result => {
      let token = result.token;
      let datosUsuario = { IdUsuario: DatosUsuario.IdUsuario, Codigo: Codigo };

      ValidaCodigo(datosUsuario, token)
      .then((result) => {
        if(result.valido === 1){
          if(localStorage.getItem("userPortafolios") !== null){
            localStorage.removeItem("userPortafolios");
          }
          localStorage.setItem("userPortafolios", JSON.stringify(DatosUsuario));
          setIsAuth(true);
        } else {
          sendSnackBar("Código incorrecto", "error");
        }
      });
    });
    setOpenDialog(false);
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    
    Login()
    .then(result => {
      let token = result.token;
      let datosLogin = { Usuario: Correo, Clave: Pass, IdAplicacion: parseInt(process.env.REACT_APP_ID) };

        UsuarioLogin(datosLogin, token)
        .then((result) => {
          if(result !== undefined){
            let data = result.resultado;

            if(data.Resultado === 1){
              let datosUsuario = { email: Correo, user: data.Usuario, idRol: data.IdRol, IdUsuario: data.IdUsuario, IdSucursales: data.IdSucursales };
              setDatosUsuario(datosUsuario);

              if(parseInt(data.IdRol) === 1){
                let datosCodigo = { Correo: data.Correo, IdUsuario: data.IdUsuario };

                ActualizaCodigo(datosCodigo, token)
                .then(result => {
                  if(result.success){
                    sendSnackBar("Correo envíado", "success");
                  }
                });
                setOpenDialog(true);
              } else {
                if(localStorage.getItem("userPortafolios") !== null){
                  localStorage.removeItem("userPortafolios");
                }
                localStorage.setItem("userPortafolios", JSON.stringify(datosUsuario));
                setIsAuth(true);
              }
            }
            else {
              sendSnackBar(data.Mensaje, "error");
            }
          }
        });
    });
  }

  if (isAuth) {
    return <Redirect to="/admin" />;
  }

  return (
    <div>
      <Header absolute color="transparent" brand="portafolios" />
      <div
        className="pageHeader"
        style={{
          backgroundColor: "white",
          backgroundSize: "cover",
          backgroundPosition: "top center"
        }}
      >
        <div className="container">
          <GridContainer justify="center" style={{ marginLeft: "15px" }}>
            <GridItem xs={12} sm={12} md={4} lg={4}>
              <Card>
                <CardHeader color="primary" className="cardHeader">
                  <h4>Login</h4>
                </CardHeader>
                <CardBody>
                  <CustomInput
                    labelText="Usuario"
                    id="email"
                    onBlur={event => {
                      setCorreo(event.target.value)
                    }}
                    formControlProps={{
                      fullWidth: true
                    }}
                    inputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Email className="inputIconsColor" />
                        </InputAdornment>
                      )
                    }}
                  />
                  <CustomInput
                    labelText="Contraseña"
                    id="pass"
                    formControlProps={{
                      fullWidth: true
                    }}
                    onBlur={event => {
                      setPass(event.target.value)
                    }}
                    inputProps={{
                      type: "password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <Icon className="inputIconsColor">
                            lock_outline
                          </Icon>
                        </InputAdornment>
                      ),
                      autoComplete: "off"
                    }}
                  />
                  <div style={{ textAlign: "end" }}>
                    <Button color="primary" onClick={(e) => handleSubmit(e)} round>
                      Iniciar sesión
                    </Button>
                  </div>
                </CardBody>
                <CardFooter className="cardFooter">
                  <p>© Portafolios {getYear()}</p>
                </CardFooter>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        <Dialog
          open={openDialog}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => setOpenDialog(false)}
          aria-describedby="AlertReferencia"
        >
          <DialogTitle>{"Se envío un código a tu correo"}</DialogTitle>
          <DialogContent>
              <DialogContentText id="AlertReferencia">
                  {`Escribelo a continuación:`}
              </DialogContentText>
              <CustomInput
                labelText="Código"
                formControlProps={{
                  fullWidth: true
                }}
                onBlur={event => {
                  setCodigo(event.target.value)
                }}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Icon className="inputIconsColor">
                        lock_outline
                      </Icon>
                    </InputAdornment>
                  ),
                  autoComplete: "off"
                }}
              />
          </DialogContent>
          <DialogActions>
              <Button color="primary" onClick={() => { Validar() }}>Aceptar</Button>
          </DialogActions>
        </Dialog>
        <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={SnackbarClose} autoHideDuration={6000}>
          <Alert onClose={SnackbarClose} severity={color} sx={{ width: '100%' }}>
              {message}
          </Alert>
        </Snackbar>
      </div>
    </div>
  );
  
}

export default LoginPage;
